(() => {
  const params = new URLSearchParams(window.location.search);
  if (window.jn && window.jn.no_animations === 1 || params.has('clean')) {
    if( params.has('clean')) {
      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('img.product-card__image--secondary').forEach(img => img.remove());
      });
    }
    return;
  }
  return;
  // ---- Timings (your values) ----
  const SHOW_ALT_MS      = 3000;   // time showing secondary
  const SHOW_MAIN_MS     = 10000;  // time back on primary
  const CARD_STAGGER_MS  = 0;    // per-card delay in a row, 800
  const ROW_DELAY_MS     = 2000;   // delay between rows
  const GLOBAL_START_MS  = 5000;   // 5s page-load delay before first flip
  const JITTER_MAX_MS    = 900;    // per-card stable jitter (0..899ms)

  const CYCLE_MS = SHOW_ALT_MS + SHOW_MAIN_MS;

  const SEL = {
    card:  '.product-card',
    media: '.product-card__media',
    prim:  '.product-card__image--primary',
    sec:   '.product-card__image--secondary',
    grid:  '[data-products], .collection-products, .product-grid, main'
  };

  // State
  const PREPARED     = new WeakSet(); // styled/bound cards
  const timersByCard = new WeakMap(); // card -> { id }
  const DEBOUNCE     = new WeakMap(); // card -> timeout id
  let T0 = null; // global epoch (Date.now()+GLOBAL_START_MS set at boot)

  // ---------- CSS (force mobile secondary visible; hover overrides) ----------
  function injectCSS(){
    if (document.getElementById('luxe-hover-override')) return;
    const css = `
      .luxe-rotator { position: relative !important; }

      /* Prestige hides secondary on touch; force visible in our scope */
      .luxe-rotator ${SEL.sec} { display: block !important; }

      /* Swap state */
      .luxe-rotator.is-swapped ${SEL.prim} { opacity: 0; }
      .luxe-rotator.is-swapped ${SEL.sec}  { opacity: 1; }

      /* Hover/focus overrides (no timer resets) */
      .luxe-rotator.force-primary  ${SEL.prim} { opacity: 1 !important; }
      .luxe-rotator.force-primary  ${SEL.sec}  { opacity: 0 !important; }
      .luxe-rotator.force-secondary ${SEL.prim} { opacity: 0 !important; }
      .luxe-rotator.force-secondary ${SEL.sec}  { opacity: 1 !important; }
    `;
    const s = document.createElement('style');
    s.id = 'luxe-hover-override';
    s.textContent = css;
    document.head.appendChild(s);
  }

  // ---------- Small helpers ----------
  function clearCardTimers(card){
    const t = timersByCard.get(card);
    if (t?.id) clearTimeout(t.id);
    timersByCard.delete(card);
  }

  function setSwap(media, toSecondary){
    media.classList.toggle('is-swapped', !!toSecondary);
    const p = media.querySelector(SEL.prim);
    const s = media.querySelector(SEL.sec);
    if (p) p.style.opacity = toSecondary ? '0' : '1';
    if (s) s.style.opacity = toSecondary ? '1' : '0';
  }

  function stylePrimary(img){
    Object.assign(img.style, {
      transition: 'opacity 800ms ease',
      willChange: 'opacity',
      opacity: '1'
    });
  }

  function styleSecondary(sec){
    sec.style.display = 'block'; // beat theme’s mobile rule
    Object.assign(sec.style, {
      position: 'absolute',
      inset: '0',
      /* remove this: pointerEvents: 'none', */
      opacity: '0',
      transition: 'opacity 2000ms ease',
      willChange: 'opacity'
    });
  }


  function bindHover(media){
    if (media.dataset.luxeBound) return;
    const onEnter = () => {
      media.classList.remove('force-primary','force-secondary');
      const showingSecondary = media.classList.contains('is-swapped');
      media.classList.add(showingSecondary ? 'force-primary' : 'force-secondary');
    };
    const onLeave = () => media.classList.remove('force-primary','force-secondary');

    // Only on the image area
    media.addEventListener('mouseenter', onEnter);
    media.addEventListener('mouseleave', onLeave);
    media.addEventListener('focus', onEnter);
    media.addEventListener('blur',  onLeave);

    media.dataset.luxeBound = '1';
  }

  // Stable per-card jitter based on product handle/href
  function getCardHandle(card){
    const direct = card.getAttribute('handle');
    if (direct) return direct;
    const link = card.querySelector(`a[href]`);
    if (link) return (link.getAttribute('href') || '').replace(/\/+$/,'');
    return (card.outerHTML || '').slice(0,256);
  }
  function djb2(str){
    let h = 5381;
    for (let i=0;i<str.length;i++) h = ((h<<5)+h) ^ str.charCodeAt(i);
    return Math.abs(h);
  }
  function stableJitterMs(card){
    const h = djb2(getCardHandle(card));
    return h % JITTER_MAX_MS;
  }

  // Re-apply styles to current imgs (keep current visual state)
  function restyleCard(card){
    const media = card.querySelector(SEL.media);
    const prim  = media?.querySelector(SEL.prim);
    const sec   = media?.querySelector(SEL.sec);
    if (!media || !prim || !sec) return false;

    media.classList.add('luxe-rotator');
    media.style.position = 'relative';

    stylePrimary(prim);
    styleSecondary(sec);

    // Preserve current visible state
    const swapped = media.classList.contains('is-swapped');
    prim.style.opacity = swapped ? '0' : '1';
    sec .style.opacity = swapped ? '1' : '0';

    bindHover(media);
    return true;
  }

  function prepCard(card){
    if (PREPARED.has(card)) return true;
    const ok = restyleCard(card);
    if (ok) PREPARED.add(card);
    return ok;
  }

  // ---------- Phase-aligned scheduler (robust & simple) ----------
  // Card joins the global cycle based on baseOffset and current time.
  function startCardWithPhase(card, baseOffsetMs){
    clearCardTimers(card);
    const media = card.querySelector(SEL.media);
    if (!media) return;

    const firstEvent = T0 + baseOffsetMs; // when this card should enter secondary
    const now = Date.now();

    // helper for modulo with positive result
    const mod = (a,b) => ((a % b) + b) % b;

    let inSecondary, msToNextFlip;

    if (now < firstEvent) {
      // Not started yet: we are in primary; next flip at firstEvent
      inSecondary   = false;
      msToNextFlip  = firstEvent - now;
    } else {
      const pos = mod(now - firstEvent, CYCLE_MS); // position within the card's cycle
      if (pos < SHOW_ALT_MS) {
        // In the secondary window
        inSecondary  = true;
        msToNextFlip = SHOW_ALT_MS - pos; // flip back to primary
      } else {
        // In the primary window
        inSecondary  = false;
        msToNextFlip = CYCLE_MS - pos;    // flip to secondary at next cycle start
      }
    }

    // Set current visual state immediately
    setSwap(media, inSecondary);

    // Loop: toggle, then wait the appropriate duration
    function tick(){
      inSecondary = !inSecondary;
      setSwap(media, inSecondary);
      const wait = inSecondary ? SHOW_ALT_MS : SHOW_MAIN_MS;
      const id = setTimeout(tick, wait);
      timersByCard.set(card, { id });
    }

    const id = setTimeout(tick, msToNextFlip);
    timersByCard.set(card, { id });
  }

  // ---------- Row grouping ----------
  const rowKey = el => Math.round(el.getBoundingClientRect().top/10);
  function computeRows(cards){
    const map = new Map();
    cards.forEach(c => {
      const key = rowKey(c);
      (map.get(key) || map.set(key, []).get(key)).push(c);
    });
    return [...map.entries()]
      .sort((a,b)=>a[0]-b[0])
      .map(([key, arr])=>{
        arr.sort((a,b)=>a.getBoundingClientRect().left - b.getBoundingClientRect().left);
        return { key, items: arr };
      });
  }

  // Initialize (or add) all rows; existing timers keep running
  function runWave(initial=false){
    const cards = [...document.querySelectorAll(SEL.card)]
      .filter(c => c.querySelector(SEL.media) && c.querySelector(SEL.prim) && c.querySelector(SEL.sec));
    if (!cards.length) return;

    const rows = computeRows(cards);

    let rowDelay = 0;
    rows.forEach(row => {
      row.items.forEach((card, idx) => {
        const ok = prepCard(card);
        if (!ok) return;

        // Stable per-card offset: row delay + per-card stagger + stable jitter
        const baseOffset = rowDelay + idx*CARD_STAGGER_MS + stableJitterMs(card);

        // Only start if not already running, or during the very first init
        if (!timersByCard.has(card) || initial) {
          startCardWithPhase(card, baseOffset);
        }
      });
      rowDelay += ROW_DELAY_MS;
    });
  }

  // ---------- Observe grid & swatch changes ----------
  function observeChanges(){
    const container = document.querySelector(SEL.grid) || document.body;

    const onMutations = (muts) => {
      let gridChanged = false;
      const touchedCards = new Set();

      for (const m of muts){
        if (m.type === 'childList'){
          const added = [...m.addedNodes].filter(n => n.nodeType === 1);
          if (added.some(n => n.matches?.(SEL.card) || n.querySelector?.(SEL.card))) {
            gridChanged = true;
          }
        }
        if (m.type === 'attributes' && m.target instanceof HTMLImageElement){
          const card = m.target.closest(SEL.card);
          if (card) touchedCards.add(card);
        }
      }

      // Re-style cards whose images changed (do NOT clear/restart timers)
      touchedCards.forEach(card => {
        clearTimeout(DEBOUNCE.get(card));
        const to = setTimeout(() => restyleCard(card), 40);
        DEBOUNCE.set(card, to);
      });

      if (gridChanged) {
        // New cards join the existing global wave
        requestAnimationFrame(() => runWave(false));
      }
    };

    const mo = new MutationObserver(onMutations);
    mo.observe(container, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['src','srcset','sizes','class','style','data-src','data-srcset']
    });
  }

  // ---------- Boot ----------
  function boot(){
    injectCSS();

    // Set the global epoch once
    if (T0 == null) T0 = Date.now() + GLOBAL_START_MS;

    const tryStart = () => {
      const prims = document.querySelectorAll(SEL.prim);
      if (prims.length) {
        runWave(true);     // initialize everything (cards align to T0)
        observeChanges();  // watch for swatches/pagination
        return true;
      }
      return false;
    };

    if (!tryStart()) {
      const id = setInterval(() => { if (tryStart()) clearInterval(id); }, 250);
      setTimeout(() => clearInterval(id), 10000);
    }
  }

  (function ensureBoot(fn){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once:true });
    } else {
      fn();
    }
  })(boot);
})();

/* accordion */
document.querySelectorAll('.clamp').forEach(cl => {
  const c = cl.querySelector('.clamp__content');
  const b = cl.querySelector('.clamp__btn');
  if (!c || !b) return;
  // After styles apply, if full content fits in the preview, hide the button and remove the clamp.
  requestAnimationFrame(() => {
    if (c.scrollHeight <= c.clientHeight + 1) {
      b.style.display = 'none';
      c.style.maxHeight = 'none';
      c.style.webkitMaskImage = 'none';
      c.style.maskImage = 'none';
    }
  });
});
